import enUS from "vant/lib/locale/lang/en-US";

export default {
  ...enUS,
  message: {
    login: 'Welcome To Login',
    lang: {
      zh: 'Chinese',
      en: 'English'
    },
  },
  invitation_login: "Invitation code login",
  mobile_verification: "Mobile verification",
  email_verification: "Email verification",
  getInto: 'Enter now',
  register: 'Sign up',
  register1: 'Registration has ended',
  submit: 'Submit',
  mailbox: 'E-mail',
  password: 'Password',
  code: 'Verification Code',
  register2: 'Sign in',
  forgotPas: 'Forgot password? Click here to retrieve your password',
  setPas: 'Reset password',
  codeTxt: 'Refresh',
  newPasword: 'New password',
  newPasword1: 'Reenter new password',
  briefInfo: 'About UCC',
  distribution: 'Floor Plan',
  agenda: 'Agenda',
  prevent: 'Epidemic prevention and control',
  promotionalVideo: 'Promotional Video',
  promise: 'Health Commitment Letter',
  checkLocation: 'Nucleic acid detection site',
  personalInfo: 'Me',
  loginRegister: 'Login',
  website: 'Website',
  video: 'Video Archive',
  album: 'Photos',
  partner: 'Organizational Partners',
  media: 'Media Partners',
  read: 'I have read it.',
  gotIt: 'I got it!',
  reg: 'Sign up',
  help: 'For assistance, please contact the meeting staff: 010-xxxxxx',
  obtain_code: 'Obtain verification code',
  yes_str: 'Yes',
  no_str: 'No',
  // 页面标题
  pageTitle: {
    China: 'Understand China',
    login: 'Login',
    distribution: 'Venue distribution',
    confirm: 'Confirmed',
    information: 'Improve Your Information',
    signUp: 'Start Registration',
    prevent: 'Epidemic prevention and control',
    promotionalVideo: 'Promotional Video',
    promise: 'Health commitment',
    personalInfo: 'Personal information'
  },
  input: {
    accountIncorrect: 'Incorrect account format',
    emailTip: 'E-mail is required.',
    phoneTip: 'phone is required.',
    invitationTip: 'Invitation code is required.',
    pasTip: 'Password must by filled.',
    locationTip: 'Please select location',
    notSame: 'The two passwords you entered are not the same.',
    codeTip: 'Verification Code is required.',
  },
  // 参会须知
  noticeDia: {
    title: 'Before You Continue',
    article1: '1. To ensure that guests can fully enjoy the rights and interests of the conference, we need to confirm your identity as a guest. Please read the following requirements and submit your information.',
    article2: '2. The information will be displayed according to the historical attendance records. You need to verify the identity information. If the information is wrong, you can modify it or contact the staff; If the information is correct, it needs to be confirmed at the meeting.',
    article3_1: '3. Time of the meeting:',
    article3_2: 'December 1, 2022 to December 5, 2022',
    article4: '4.其他说明规则文案内容其他说明规则文案内容其他说明规则文案内容其他说明规则文案内容其他说明规则文案内容。',
    article5: 'Conference Tel.: 010-xxxxxxxx'
  },
  photoDia: {
    title: 'Conference Badge',
    article1: '(1) A recently-taken color photo (bare-head, the face should take up more than half of the photograph);',
    article2: '(2) Background: White;',
    article3: '(3) Size: 390*568, 300 pixels;',
    article4: '(4) Format: jpg, jpeg, png, within size of 100K-5M.',
  },
  resumePhotoDia: {
    title: 'Resume Photo',
    article1: '(1) A recent single-person color headshot_vertical;',
    article2: '(2) Size: 1000*1500, 300 pixels;',
    article3: '(3) Format: jpg, jpeg, png;',
    article4: '(4) Size of 100K-5M',
  },
  statementDia: {
    title: 'Please upload your conference speech manuscript (if any) here.',
    article1: '(1) Format: doc, docx, ppt, pptx, pdf, rar, zip, 7z;',
    article2: '(2) Size: limit 50M.'
  },
  mediaDia: {
    title: 'Notice for the Media',
    article1: '1. In order to ensure that media reporters can fully enjoy the rights and interests of the conference, we need to confirm your media identity. Please read the following requirements and submit your information.',
    article2: '2. If you have passed the certification in the previous general meeting, you cannot directly obtain your participation qualification in the new general meeting. You need to register again.',
    article3_1: '3. Certification data shall be submitted',
    article3_2: 'Print media / news agencies, radio and television news media, network media, please provide: business card or press card.',
    article3_3: 'We media person, KOL, please provide us media data screenshot. Industry analyst, please provide: business card',
    article4: '4. Once the information is submitted, the registration is successful. The staff will review your information and send you confirmation information through the review meeting. You can sign in with the confirmation email or registered mobile phone number to receive the badge during the conference.',
  },
  uploadDia: {
    title: 'Attachments',
    article1: '(1) E-copy of data page of Press Card/Other Certificates',
    article2: '(2) Format: jpg, jpeg, png;',
    article3: '(3) Size of 100K-5M',
  },
  confirmDia: {
    title: '', // 'You have entered',
    message: 'Please make sure every detail you have entered is correct and up to standard before submission.',
    confirm: 'Submit',
    cancel: 'Go back'
  },
  // 步骤条
  steps: {
    person: 'Basic information',
    contact: 'Contact Information',
    active: 'Session attendance confirmation',
    statement: 'Statement',
    trip: 'Arrival & Departure',
    interview: 'Interview requests',
    arriveLeave: 'Departure & Arrival'
  },
  // 表单
  form: {
    title: {
      basic: 'Basic information',
      post: 'Title',
      resume: 'Profile',
      other: 'Additionals',
      person: 'Personal Contact Information',
      work: 'Work Contact Information',
      urgent: 'Emergency Contact Information',
      forum: 'Thematic forum',
      workshop: 'Symposium',
      arrive: 'Arrival Information',
      leave: 'Departure Information',
      accommodation: 'Accomodation',
      statement: 'speech/presentation supporting materials'
    },
    label: {
      enter: 'Please input ...',
      choice: 'Please select ...',
      surnameCh: 'Last Name (Chinese)',
      nameCh: 'First Name (Chinese)',
      nameCh_I: 'Full Name (Chinese)',
      surnameEn: 'Last Name (English)',
      nameEn: 'First Name (English)',
      nameEn_I: 'Full Name (English)',
      fullName: 'Full Name',
      photo: 'Photo',
      resumePhoto: 'Resume Photo',
      birth: 'Date of Birth',
      gender: 'Gender',
      nationality: 'Country',
      nation: 'Ethnic Group',
      country: 'Representing',
      diet: 'Dietary preference',
      documentType: 'ID Type',
      documentNum: 'ID Number',
      documentVal: 'Date of Expiry',
      permanent: 'Permanent',
      validUntil: 'Valid until',
      companyCh: 'Title (Chinese)',
      companyEn: 'Title (English)',
      researchField: 'Research Field(s)',
      guangzhouLevel: 'Administrative Level',
      joinType: 'Join Type',
      company: 'Agency',
      postCh: 'Post（CN）',
      postEn: 'Post（EN）',
      post: 'Working as',
      resumeCh: 'Profile (Chinese)',
      resumeChPlaceholder: 'Please input ...',
      resumeEn: 'Profile (English) ',
      resumeEnPlaceholder: 'Please input ...',
      vaccinated: 'Vaccinated',
      vaccinePhoto: 'Please upload your vaccination certificate.',
      uploadPhoto: 'Upload photos',
      next: 'Continue',
      previous: 'Go back',
      mail: 'E-mail',
      initialPas: 'The initial password is 123456',
      phone: 'Cell Number',
      region: 'Based in',
      address: 'Address Details',
      contact: {
        work: 'Work Contacts',
        urgent: 'Emergency Contacts'
      },
      pichUp: 'Airport/train station pick-up (for those such services are offered in their invitation only)',
      delivery: 'Airport/train station drop-off (for those such services are offered in their invitation only)',
      travel: 'Arriving in GZ by',
      lk_travel: 'Departing from GZ by',
      number: 'Flight/Train Number',
      seat: 'Class/Seat Number',
      depTime: 'Time of Departure',
      depAddress: 'Place of Departure',
      arrTime: 'Time of Arrival',
      destination: 'Destination',
      accommodation: 'Accomodation',
      submitAndConfirm: 'Submit and Confirm to Attend',
      submit: 'Submit',
      havePress: 'Press Credential',
      pressCard: 'Press Credential',
      pressID: 'Press Card No.',
      otherInfo: 'Other supporting files',
      uploadAtta: 'Upload attachments',
      deviceInfo: 'Equipment info',
      interview: {
        object: 'Interviewee (s) in mind',
        date: 'Proposed Date',
        time: 'Proposed Time',
        theme: 'Proposed Topic(s)',
        problem: 'Question List'
      },
      briefInfo: 'Introduction',
      briefInfoEnter: 'Please input ...',
      Participants: 'Role',
      explain: 'Reason(s) for non-vaccination',
      WeChat: 'Weixin ID',
      needInvitationLetter: 'Do you need a visa invitation letter'
    }
  },
  upload_photo: {
    title: 'Upload Image',
    avatar_str: 'Conference Badge',
    avatar_tip1: '(1) A recently-taken color photo (bare-head, the face should take up more than half of the photograph);',
    avatar_tip2: '(2) Background: White;',
    avatar_tip3: '(3) Size: 390*568, 300 pixels;',
    avatar_tip4: '(4) Format: jpg, jpeg, png, within size of 100K-5M',
    photo_str: 'Resume photo',
    photo_tip1: '(1) A recent single-person color headshot_vertical;',
    passport_str: 'Passport personal information page',
    passport_tip1: "(1) A nice and clear copy of the bio-data page of your current passport.",
    passport_tip2: '(2) Size: 390*290, 300 pixels;',
    passport_tip3: '(3) Format: jpg, jpeg, png, within size of 100K-5M',
  },
  infoTip: 'Recommations by the Organizing Committee shall prevail.',
  infoTipGti: 'Please click & select to confirm attendance.',
  interviewInfoTip: 'Our staff will confirm with you and arrange your interviews according to your interview preference.',
  date: {
    one: 'December 1st',
    two: 'December 2nd',
    three: 'December 3rd',
    four: 'December 4th',
    five: 'December 5th',
    six: 'December 6th'
  },
  special: {
    forum1: 'Special forum I: new era, new youth and new responsibilities',
    forum2: 'Special forum II: volunteer service with Chinese characteristics',
    forum3: 'Special forum 3: reading Chinese TV dialogue',
    forum4: 'Special forum 4: education and health in China',
    forum5: 'Special forum V: sustainable development of cultural heritage in a new perspective',
    workshop1: 'Seminar 1: new journey of China`s modernization and new opportunities for global cooperation',
    workshop2: 'Understanding Guangzhou Symposium II: scientific and technological innovation and advanced manufacturing',
    workshop3: 'Symposium III: hub economy',
    workshop4: 'Signing ceremony of international communication strategic cooperation in Guangdong, Hong Kong and Macao Greater Bay Area',
    workshop5: 'Seminar 3: international anti epidemic cooperation and human health community',
    workshop6: 'Seminar 8: cultural exchanges and mutual learning and telling the Chinese story',
    other1: 'Press conference of "reading China" series (Volume II)',
    other2: 'At the signing ceremony of "read China" international communication cooperation, the signing ceremony of "read China" international communication cooperation was opened',
    other: 'buffet lunch'
  },
  forum: 'Thematic forum',
  workshop: 'Symposium',
  other: 'Other schedules',
  dinner: 'Meal arrangement',
  parallel: 'Parallel Seminar',
  floors: {
    one: '1st floor',
    two: '2nd floor',
    three: '3rd floor',
    four: '4th floor',
    five: '5th floor',
    six: '6th floor',
    seven: '7th floor'
  },
  leader: 'leader',
  survey: 'Overview of the conference',
  host: 'Sponsored by: National Innovation Association',
  CoOrganizer: 'Co organizer: name of CO organizer 1, name of CO organizer 2',
  time: 'Meeting time: ', // 2021-12-1 ~ 2021-12-5
  address: 'Venue: ', // No. 498, Binjiang East Road, Zhuhai district, Guangzhou (Haihai Yinqiao bridge)
  partnerList: {
    one: 'Chinese People`s Institute of Foreign Affairs',
    two: 'Party School of the CPC Central Committee',
    three: 'Chinese Academy of Sciences',
    four: 'China foreign language publishing and Distribution Bureau'
  },
  // 健康承诺书
  health: {
    title: 'Health commitment',
    text: 'I solemnly promise as follows:',
    text1: '1、 I have no fever, cough, fatigue and other symptoms consistent with COVID-19.',
    text2: '2、 I and my family members living together have not been diagnosed with confirmed or suspected cases of COVID-19.',
    text3_1: '3、 I have not been in contact with suspected, confirmed and asymptomatic COVID-19 patients recently, and',
    text3_2: 'the isolation period of 14 days has passed',
    text3_3: ',and there were no symptoms consistent with COVID-19 during the isolation period.',
    text4: '4、 There has been no confirmed case within 14 days in the community, unit building, village group or work unit where I live.',
    text5: '5、 I will strictly follow the COVID-19 epidemic prevention requirements, cooperate with the community (Village) and community property management personnel to carry out epidemic prevention work, and truthfully declare my personal health status. Do a good job in personal protection, develop good living and health habits, and actively participate in volunteer activities arranged by the community (Village).',
    text6: '6、 I am responsible for the authenticity of the health information provided above. If the epidemic situation spreads and spreads due to the false information, I am willing to bear all legal responsibilities arising therefrom.',
    check1: 'No history of heart disease',
    check2: 'No other medical history',
    Promisor: 'Accepter: ', // Zhang Wei
    PromisorPhone: 'Cell Number：',
    PromisorIdNumber: 'Id Number：',
    '7days': 'Travel history within the past 7 days：',
    button1: 'I have read and agree to commitment.',
    button2: 'Committed'
  },
  routeTitle: {
    understandChina: 'Understanding China',
    login: 'Login',
    health: 'Health Commitment Letter',
    promotionalVideo: 'Promotional Video',
    improve: 'Improve Your Information',
    floor: 'Floor Plan',
    agenda: 'Agenda',
    personal: 'Me',
    arrangeSearch: '排座搜索',
    video: 'Video Archive',
    notify: 'Notifications',
    setting: 'Settings',
    changePassword: 'Change Password',
    cooperation: 'Organizational Partners',
    confirm: 'Confirmed',
    register: 'Start Registration'
  },
  personal: {
    tab0: 'Registration',
    tab1: 'Event Info',
    tab2: 'Traffic Info',
    tab3: 'Hotel Info',
    tab4: 'Meal Info',
    tab5: 'Contact Info',
    tab6: '大会信息',
    item2: {
      go: 'Departure',
      back: 'Return'
    },
    Registration: {
      information: 'Registration',
      edit: 'Modify',
      view: 'View',
      filling: 'Filling'
    },
    Accommodation: {
      checkin: '入住',
      leave: '退房'
    }
  },
}